import { Link } from "react-router-dom";
import { useState } from "react";
import { Mail } from "lucide-react";
import { SITE_CONFIG, NAV_LINKS } from "@/config/site";

export const Footer = () => {
  
const [showCookiePopup, setShowCookiePopup] = useState(false);

const [cookieSettings, setCookieSettings] = useState({
  essentials: true,
  functionality: false,
  analytics: false,
  advertising: false,
});

const handleToggle = (key) => {
  // Prevent disabling essentials
  if (key === "essentials") return;

  setCookieSettings((prev) => ({
    ...prev,
    [key]: !prev[key],
  }));
};

// const handleAcceptAll = () => {
//   setCookieSettings({
//     essentials: true,
//     functionality: true,
//     analytics: true,
//     advertising: true,
//   });

//   setShowCookiePopup(false);
// };

// const handleAcceptAll = () => {
//   setCookieSettings({
//     essentials: true,
//     functionality: true,
//     analytics: true,
//     advertising: true,
//   });
// }

const handleAcceptAll = () => {
  const allSelected =
    cookieSettings.functionality &&
    cookieSettings.analytics &&
    cookieSettings.advertising;

  setCookieSettings({
    essentials: true,
    functionality: !allSelected,
    analytics: !allSelected,
    advertising: !allSelected,
  });
};

const handleRejectAll = () => {
  setCookieSettings({
    essentials: true,
    functionality: false,
    analytics: false,
    advertising: false,
  });

  setShowCookiePopup(false);
};

const handleConfirmSelection = () => {
  setShowCookiePopup(false);
};

  return (
    <footer className="relative pt-20 pb-10 border-t border-white/10 footer-pattern" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-16">
          {/* Logo & Description */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="/QVPN_Logo_New.svg" 
                alt="QVPN Logo" 
                className="w-16 h-16 rounded-lg object-contain"
              />
              <span className="text-xl font-bold text-white">{SITE_CONFIG.brand.name}</span>
            </Link>
            <p className="text-gray-400 text-sm mb-4 max-w-xs">
              {SITE_CONFIG.brand.description}
            </p>
            
            {/* Support Email */}
            {/* <a 
              href={`mailto:${SITE_CONFIG.contact.supportEmail}`}
              className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors mb-6"
            >
              <Mail className="w-4 h-4" />
              {SITE_CONFIG.contact.supportEmail}
            </a> */}

            {/* Legal Disclosure */}
            {/* <p className="text-xs text-gray-500 max-w-xs">
              {SITE_CONFIG.legal.operatorDisclosure}
            </p> */}
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              {NAV_LINKS.footer.product.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {NAV_LINKS.footer.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="text-white font-semibold mt-4 mb-4">Socials</h4>
            <ul className="space-y-3">
              {NAV_LINKS.footer.socials.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href} target="_blank"
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-3">
              {NAV_LINKS.footer.support.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              {/* {NAV_LINKS.footer.legal.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))} */}
            {NAV_LINKS.footer.legal.map((link) => (
              <li key={link.name}>
                {link.name === "Cookie Preferences" ? (
                  <button
                    type="button"
                    onClick={() => setShowCookiePopup(true)}
                    className="text-left text-gray-400 hover:text-white text-sm leading-5 whitespace-normal transition-colors duration-200"
                  >
                    {link.name}
                  </button>
                ) : (
                  <Link
                    to={link.href}
                    className="text-left text-gray-400 hover:text-white text-sm leading-5 whitespace-normal transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                )}
              </li>
            ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col flex-col-reverse md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {SITE_CONFIG.legal.copyrightYear} {SITE_CONFIG.brand.name}. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs">
              Operated by {SITE_CONFIG.legal.operatorName}
            </p>
            {/* <p className="text-gray-500 text-xs mt-1">
              {SITE_CONFIG.legal.businessAddress}
            </p> */}
          </div>
          {/* <div className="flex items-center justify-center gap-6 mt-4">
            <Link 
              to="/privacy" 
              className="text-gray-500 hover:text-white text-sm transition-colors duration-200"
              data-testid="footer-privacy"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-500 hover:text-white text-sm transition-colors duration-200"
              data-testid="footer-terms"
            >
              Terms of Service
            </Link>
            <Link 
              to="/contact" 
              className="text-gray-500 hover:text-white text-sm transition-colors duration-200"
              data-testid="footer-contact"
            >
              Contact
            </Link>
          </div> */}
        </div>
      </div>     
        
        {showCookiePopup && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 popupblk">

          <div className="relative w-full max-w-2xl">

  <div className="rounded-[28px] border cardbg shadow-2xl overflow-hidden1">

    <div className="hide-scrollbar p-6 md:p-8 overflow-y-auto max-h-[90vh]">

            {/* Close Button */}
            <button
              onClick={() => setShowCookiePopup(false)}
              className="absolute btn-position flex items-center justify-center rounded-full bg-gray-800 text-2xl text-red-400 hover:bg-gray-700"
            >
              ×
            </button>

            {/* Header */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-white mb-5">
                Cookie Preferences
              </h2>

              <p className="text-slate-400 text-sm leading-7 mb-4">
                We use cookies for security, functionality, analytics, and personalized advertising with trusted partners like Google. Learn more in{" "}
                <Link
                  target="_blank"
                  to="https://business.safety.google/privacy/"
                  className="text-emerald-400 hover:text-emerald-300"
                >
                  Google's Privacy & Terms
                </Link>.
              </p>

              <p className="text-slate-400 text-sm leading-7">
                By clicking “Accept All”, you agree to our use of cookies as described in our{" "}
                <a
                  href="/privacy"
                  className="text-emerald-400 hover:text-emerald-300"
                >
                  Privacy Policy
                </a>. Preferences can be updated anytime.
              </p>
            </div>

            {/* Select All */}
            <button
              onClick={handleAcceptAll}
              className="w-full rounded-2xl border border-emerald-400 bg-[#041c12] px-5 py-4 text-left text-emerald-300 font-semibold mb-6 flex items-center gap-3"
            >

              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center border border-emerald-400 ${
                  cookieSettings.functionality &&
                  cookieSettings.analytics &&
                  cookieSettings.advertising
                    ? "bg-emerald-500"
                    : "bg-transparent"
                }`}
              >
                {cookieSettings.functionality &&
                  cookieSettings.analytics &&
                  cookieSettings.advertising && (
                    <span className="text-xs text-black">✓</span>
                  )}
              </span>

              <span>Select All</span>

            </button>

            {/* Cookie Items */}
            <div>

              {/* Essentials */}
              <div className="flex items-start gap-4 border-b border-white/10 py-5">

                <button
                  disabled
                  className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded- border border-emerald-400 bg-emerald-500"
                >
                  <span className="text-xs text-black">✓</span>
                </button>

                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="text-lg font-semibold text-white">
                      Essentials
                    </h4>

                    <span className="rounded-full bg-slate-700 px-2 py-0.5 text-[11px] text-slate-300">
                      Required
                    </span>
                  </div>

                  <p className="text-sm text-slate-400">
                    These cookies ensure the functionality of the website and enhance its security.
                  </p>
                </div>
              </div>

              {/* Functionality */}
              <div className="flex items-start gap-4 border-b border-white/10 py-5">

                <button
                  onClick={() => handleToggle("functionality")}
                  className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded- border transition ${
                    cookieSettings.functionality
                      ? "border-emerald-400 bg-emerald-500"
                      : "border-green-400/40 bg-transparent"
                  }`}
                >
                  {cookieSettings.functionality && (
                    <span className="text-xs text-black">✓</span>
                  )}
                </button>

                <div>
                  <h4 className="text-lg font-semibold text-white mb-1">
                    Functionality
                  </h4>

                  <p className="text-sm text-slate-400">
                    These cookies let us remember your key preferences, like language settings.
                  </p>
                </div>
              </div>

              {/* Analytics */}
              <div className="flex items-start gap-4 border-b border-white/10 py-5">

                <button
                  onClick={() => handleToggle("analytics")}
                  className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded- border transition ${
                    cookieSettings.analytics
                      ? "border-emerald-400 bg-emerald-500"
                      : "border-green-400/40 bg-transparent"
                  }`}
                >
                  {cookieSettings.analytics && (
                    <span className="text-xs text-black">✓</span>
                  )}
                </button>

                <div>
                  <h4 className="text-lg font-semibold text-white mb-1">
                    Analytics
                  </h4>

                  <p className="text-sm text-slate-400">
                    Above settings help us analyze usage and improve performance.
                  </p>
                </div>
              </div>

              {/* Advertising */}
              <div className="flex items-start gap-4 py-5">

                <button
                  onClick={() => handleToggle("advertising")}
                  className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded- border transition ${
                    cookieSettings.advertising
                      ? "border-emerald-400 bg-emerald-500"
                      : "border-green-400/40 bg-transparent"
                  }`}
                >
                  {cookieSettings.advertising && (
                    <span className="text-xs text-black">✓</span>
                  )}
                </button>

                <div>
                  <h4 className="text-lg font-semibold text-white mb-1">
                    Advertising
                  </h4>

                  <p className="text-sm text-slate-400">
                    Above settings help deliver personalized ads through trusted third-party partners.
                  </p>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="mt-8 flex flex-col md:flex-row gap-4">

              {/* <button
                onClick={handleRejectAll}
                className="flex-1 rounded-xl border border-red-500/30 bg-red-500/10 px-5 py-4 font-semibold text-red-400"
              >
                Reject All
              </button> */}

              <button
                onClick={handleConfirmSelection}
                className="flex-1 rounded-xl bg-neutral-100 px-5 py-4 btn-gradient-new"
              >
                ✓ Submit
              </button>

            </div>
          </div>
        </div>
        </div>
        </div>
      )}

    </footer>
  );
};

export default Footer;
